<!-- 上传图片组件 - 签单专用 -->
<template>
	<div>
		<el-upload :on-success="handleAvatarSuccess" :before-upload="beforeUpload" :action="action"
			list-type="picture-card" :on-preview="handlePictureCardPreview" :file-list="imgs" :multiple="true"
			:limit="img_num" :on-change="handleLimit" :class="{disabled:uploadDisabled,xiang_size:xiang_size}" :on-remove="handleRemove"
			:data="data">
			<i class="el-icon-plus"></i>
		</el-upload>
		<el-dialog :visible.sync="dialogVisible" append-to-body>
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>


</template>

<script>
	import {
		getToken,
	} from '@/tool/cookie'
	import {
		getBaseUrl
	} from '@/tool/index'
	import Qs from 'qs'
	export default {
		data() {
			return {
				action: getBaseUrl() + 'SignShop/uploadImg',
				dialogImageUrl: '', // 图片上传
				dialogVisible: false, // 图片上传
				imgs: [], // 存储的图片数据
				uploadDisabled: false, // 图片上传图标是否显示
				data: {
					'login_uid': '',
					'token': '',
				}
			};
		},
		props: { // 定义组件的属性
			img_num: { // 限制上传的图片数量
				type: Number,
				default: 1,
			},
			index: { // 父组件的索引
				type: Number,
				default: 0,
			},
			img_edit: { // 定义默认的图片列表
				type: Array | String,
				default: [],
			},
			xiang_size:{
				type: Number,
				default: 0,
			}
		},
		created() {
			this.data.login_uid = getToken('login_uid');
			this.data.token = getToken('token');
			this.resetImg()
		},
		watch: {
			img_edit() { // 监听img_edit的变化
				this.resetImg()
			},
		},
		methods: {
			resetImg() {
				this.imgs = this.img_edit;
				if (this.imgs == '') {
					this.imgs = [];
				}
				this.imgNumCheck(this.img_edit.length)
			},
			beforeUpload(file) { // 上传之前的操作
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG && !isPNG) {
					return this.$message.error('上传头像图片只能是 JPG或者PNG 格式!');
				}
				if (!isLt2M) {
					return this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return true;
			},
			handlePictureCardPreview(file) { // 点击文件列表中已上传的文件时的钩子
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handleAvatarSuccess(res, file, file_list) { // 上传成功的操作
				file.url = file.response.key;
				this.$emit("imgList", file_list, this.index);
			},
			handleRemove(file, fileList) { // 图片删除后的操作
				this.imgs = fileList;
				this.imgNumCheck(fileList.length)
				this.$emit("imgList", fileList, this.index);
			},
			handleLimit(file, fileList) { //限制图片张数，文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
				this.imgNumCheck(fileList.length)
			},
			imgNumCheck(length) { // 判断图片的张数，用来显示和隐藏
				if (length >= this.img_num) {
					this.uploadDisabled = true;
				} else {
					this.uploadDisabled = false;
				}
			}
		}
	}
</script>

<style>
	/* .el-upload--picture-card 控制图片上传加号部分 */
	.disabled .el-upload--picture-card {
		display: none !important;
	}

	.xiang_size .el-upload--picture-card {
		width: 400px;
		height: 400px;
	}

	.xiang_size .el-upload {
		width: 400px;
		height: 400px;
		line-height: 400px;
	}

	.xiang_size .el-upload-list--picture-card .el-upload-list__item {
		width: 400px;
		height: 400px;
		line-height: 400px;
	}

	.xiang_size .el-upload-list--picture-card .el-upload-list__item-thumbnail {
		width: 400px;
		height: 400px;
		line-height: 400px;
		object-fit: cover;
	}

	.xiang_size .avatar {
		width: 400px;
		height: 400px;
	}
</style>
